// `GET /api/permissions` is global: no tenant segment, so this Query carries no parameter.
class FetchPermissionCatalog {
	constructor() {
		Object.freeze(this);
	}
}

export default FetchPermissionCatalog;
